import {
  defaultBorders,
  defaultLayouts,
  defaultPadding,
  GSItemList,
} from "golfstatus_react_components";
import { useDispatch, useSelector } from "react-redux";
import {
  addTournamentPackageToOrderThunk,
  deleteTournamentRegistrationOrderItemThunk,
  removeTournamentPackageFromOrderThunk,
  selectRegistrationOrder,
} from "../../reducers/registrationOrderSlice";
import RegistrationOrderLineItem from "../events/event/packages/registration-order-line-item";
import { useTheme } from "../../hooks/themeHooks";
import { useGolfstatusNavigate } from "../../hooks/navigationHooks";

const CartMyPackagesWidget = () => {
  const registrationOrder = useSelector(selectRegistrationOrder);

  const [, theme, getStyle] = useTheme();

  const navigate = useGolfstatusNavigate();
  const dispatch = useDispatch();

  const addPackage = (tournamentPackage) => {
    dispatch(addTournamentPackageToOrderThunk({registrationOrder, tournamentPackage}))
  };

  const decrementPackage = (orderItem) => {
    dispatch(removeTournamentPackageFromOrderThunk(orderItem))
  };

  const removePackage = (orderItem) => {
    dispatch(deleteTournamentRegistrationOrderItemThunk({...orderItem, registrationOrder}));
  };

  return (
    <GSItemList
      type="vertical large-gap"
      style={{ ...defaultLayouts.fullWidth }}
      items={registrationOrder?.registrationOrderItems}
      listItem={(p) => (
        <RegistrationOrderLineItem
          {...p}
          style={{
            ...defaultLayouts.fullWidth,
            ...getStyle(theme.surfaceVariant),
            ...defaultPadding.xLargePad,
            ...defaultBorders.largeBorderRadius,
          }}
          formSelected={(form) => {
            navigate(`${p.id}/${form.type}?id=${form.id}`);
          }}
          addPackage={addPackage}
          decrementPackage={decrementPackage}
          removePackage={removePackage}
        />
      )}
    />
  );
};

export default CartMyPackagesWidget;
